import { render, staticRenderFns } from "./DeleteButton.vue?vue&type=template&id=10625aa3&scoped=true&lang=pug&"
import script from "./DeleteButton.vue?vue&type=script&lang=ts&"
export * from "./DeleteButton.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteButton.vue?vue&type=style&index=0&id=10625aa3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10625aa3",
  null
  
)

export default component.exports